<script>
	import { Router, Route } from "svelte-routing";
    import FirebaseActions from './FirebaseActions.svelte';
    import ResetPassword from './ResetPassword.svelte';
    import SendResetEmail from './SendResetEmail.svelte';
    import SignIn from './SignIn.svelte';
    import SignUp from './SignUp.svelte';
    import SignUpSuccessful from './SignUpSuccessful.svelte';
    import VerifyEmail from './VerifyEmail.svelte';
</script>

<Router>
	<Route path="/auth/action" component={FirebaseActions} />
	<Route path="/auth/reset-password" component={ResetPassword} />
	<Route path="/auth/send-reset-email" component={SendResetEmail} />
	<Route path="/auth/sign-in" component={SignIn} />
	<Route path="/auth/sign-up" component={SignUp} />
	<Route path="/auth/sign-up-successful" component={SignUpSuccessful} />
	<Route path="/auth/verify-email" component={VerifyEmail} />
</Router>